import styles from './TextSection.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React from 'react';

import {
  TestimonialAssembly,
  TextAlignment
} from 'src/api/contentful/contentTypes.cloverdotcom';
import { ContentLink } from 'src/components/ContentLink/ContentLink';
import { Merchant } from 'src/components/Testimonial/Text/Merchant';
import { QuotesIcon } from 'src/components/Testimonial/Text/QuotesIcon';
import { isEntry } from 'src/utils/EntryUtil';

interface TextSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  entry?: ReferencedEntry<TestimonialAssembly>;
  withCarousel?: boolean;
}

export const TextSection: React.FC<TextSectionProps> = ({ entry, className, withCarousel, ...props }) => {

  if (!isEntry(entry)) return null;

  const {
    testimony,
    merchant,
    color = '#000',
    backgroundColor = '#fff',
    textBoxAlignment = TextAlignment.RIGHT,
  } = entry.fields;

  if (!isEntry(testimony)) return null;

  const { blurb, link } = testimony.fields;

  return (
    <div
      style={{ color, backgroundColor }}
      className={cx(
        styles.textSection,
        { [styles.textSectionLeftAlign]: textBoxAlignment === TextAlignment.LEFT },
        { [styles.textSectionWithCarousel]: withCarousel },
        className
      )}
      {...props}
    >
      <div className={styles.quoteSection}>
        <div style={{ backgroundColor }} className={styles.quotesIconWrapper}>
          <QuotesIcon color={color} />
        </div>
        <h3 style={{ color }} className={styles.quote}>
          {blurb}
        </h3>
      </div>

      <Merchant entry={merchant} className={styles.merchant} />

      <ContentLink entry={link} className={styles.ctaButton} />
    </div>
  );
};
